import type { ReactNode } from "react";

import { Button, type ModalProps } from "@/ui";
import { Modal } from "@/ui";

export type ConfirmDialogProps = {
  title: string;
  description?: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  destructive?: boolean;
  isConfirming?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  isOpen: boolean;
} & Pick<ModalProps, "closeEnabled">;

export const ConfirmDialog = ({
  cancelLabel = "Cancel",
  closeEnabled,
  confirmLabel,
  description,
  destructive = false,
  isConfirming = false,
  isOpen,
  onClose,
  onConfirm,
  title,
}: ConfirmDialogProps) => {
  return (
    <Modal closeEnabled={closeEnabled} closeModal={onClose} isOpen={isOpen} size="sm">
      <div className="flex flex-col gap-6 p-6 sm:p-8">
        <div className="flex flex-col gap-2 pr-8">
          <h2 className="text-xl font-bold text-balance text-content sm:text-2xl">{title}</h2>

          {description ? (
            <div className="leading-relaxed text-content-secondary">{description}</div>
          ) : null}
        </div>

        {/* Stacked on a phone so neither action is a thumb-stretch, side by side above it. */}
        <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
          <Button
            className="sm:w-auto"
            disabled={isConfirming}
            onClick={onClose}
            variant="secondary-dark"
          >
            {cancelLabel}
          </Button>

          <Button
            className="sm:w-auto"
            isLoading={isConfirming}
            onClick={onConfirm}
            variant={destructive ? "danger" : "primary"}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
